<template>
  <!-- Page container -->
  <div class="page-container">
    <!-- Page content -->
    <div class="page-content">
      <!-- Main content -->
      <div class="content-wrapper">
        <!-- Cover area -->
        <div class="profile-cover">
          <div
            v-if="loggedInUserData.cover_image == null || loggedInUserData.cover_image == ''"
            class="profile-cover-img img-responsive"
            :style="{ backgroundImage: 'url(../../../assets/images/cover_placeholder.png)' }"
          ></div>
          <div
            v-else
            class="profile-cover-img img-responsive"
            :style="{ backgroundImage: `url(${$_image_path()}${loggedInUserData.cover_image})` }"
          ></div>

          <div class="media">
            <div class="media-left">
              <a
                @click="openExplorer()"
                href="#"
                class="profile-thumb"
              >
                <img
                  v-if="
                    loggedInUserData.profile_image == null || loggedInUserData.profile_image == ''
                  "
                  src="../../../assets/images/Profile_avatar.png"
                  class="img-circle"
                />
                <img
                  v-else
                  :src="$_image_path() + loggedInUserData.profile_image"
                  class="img-circle"
                />
              </a>
            </div>
            <div class="media-body">
              <h1 class="pt-3">{{ loggedInUserData.full_name }}</h1>
              <span>Customer ID: {{ loggedInUserData.user_id }}</span>
            </div>

            <div class="media-left media-middle">
              <div style="height:0px;overflow:hidden">
                <form
                  @submit.prevent="submit($event)"
                  enctype="multipart/form-data"
                >
                  <input
                    type="file"
                    name="profile_image"
                    id="profile_image"
                    value=""
                  />
                  <v-btn
                    id="updateButton"
                    type="submit"
                    style="height:auto"
                    outline
                    color="success"
                  >Add</v-btn>
                </form>
              </div>
            </div>

            <div class="media-right media-middle">
              <form
                @submit.prevent="submitCover($event)"
                enctype="multipart/form-data"
              >
                <div style="height:0px;overflow:hidden">
                  <input
                    type="file"
                    name="cover_image"
                    id="cover_image"
                    value=""
                  />
                  <v-btn
                    id="updateCoverButton"
                    type="submit"
                  ></v-btn>
                </div>
                <v-btn
                  @click="openCoverExplorer()"
                  style="height:auto;width:60%"
                  color="white"
                >Update Cover Image</v-btn>
              </form>
            </div>
          </div>
        </div>
        <!-- /cover area -->

        <!-- Toolbar -->
        <div class="navbar navbar-default navbar-xs content-group">
          <ul class="nav navbar-nav visible-xs-block">
            <li class="full-width text-center">
              <a
                data-toggle="collapse"
                data-target="#navbar-filter"
              ><i
                  class="fa fa-align-justify"
                  style="font-size: 20px"
                ></i></a>
            </li>
          </ul>
          <div class="navbar navbar-default navbar-xs navbar-component no-border-radius-top">
            <div
              class="navbar-collapse collapse"
              id="navbar-filter"
            >
              <ul class="nav navbar-nav">
                <li class="active">
                  <a
                    href="#activity"
                    data-toggle="tab"
                  ><i
                      class="fa fa-user"
                      style="font-size: 16px"
                    ></i> &nbsp;Personal
                    Information</a>
                </li>
                <li v-if="loggedInUserData.is_staff">
                  <a
                    href="#settings"
                    data-toggle="tab"
                  ><i
                      class="fa fa-key"
                      style="font-size: 16px"
                    ></i> &nbsp; Change Password</a>
                </li>
                <li v-if="$_has_perm('add_secret_key')">
                  <a
                    href="#create-secret"
                    data-toggle="tab"
                  ><i
                      class="fa fa-key"
                      style="font-size: 16px"
                    ></i> &nbsp;Create Secret Key</a>
                </li>
                <li v-if="$_has_perm('edit_secret_key')">
                  <a
                    href="#secret"
                    data-toggle="tab"
                  ><i
                      class="fa fa-key"
                      style="font-size: 16px"
                    ></i> &nbsp; Change Secret Key</a>
                </li>
                <li v-if="$_has_perm('add_edit_company_info')">
                  <a
                    href="#company"
                    data-toggle="tab"
                  ><i
                      class="fa fa-group"
                      style="font-size: 16px"
                    ></i> &nbsp; Company Info</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /toolbar -->

        <!-- User profile -->
        <div class="row">
          <div class="col-lg-12">
            <div class="tabbable">
              <div class="tab-content">
                <!-- PERSONAL INFORMATION -->
                <div
                  class="tab-pane fade in active"
                  id="activity"
                >
                  <div class="panel panel-flat">
                    <div class="panel-heading">
                      <h3 class="panel-title">Personal Information</h3>
                    </div>

                    <div class="panel-body">
                      <div>
                        <br />
                        <v-alert
                          :value="successResponse"
                          type="success"
                        >
                          {{ successMessage }}
                        </v-alert>
                        <v-alert
                          :value="errorResponse"
                          type="error"
                        >
                          {{ errorMessage }}
                          {{ errorMessages.email }}
                          {{ errorMessages.phone_number }}
                        </v-alert>
                        <form @submit.prevent="updateProfile(loggedInUserData.user_id)">
                          <div class="row">
                            <v-flex class="col-sm-12 col-md-6">
                              <v-text-field
                                v-model="loggedInUserData.full_name"
                                name="full_name"
                                label="Full Name"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex class="col-sm-12 col-md-6">
                              <v-text-field
                                v-model="loggedInUserData.email"
                                name="email"
                                label="Email"
                              >
                              </v-text-field>
                            </v-flex>
                          </div>
                          <div class="row">
                            <v-flex class="col-sm-12 col-md-6">
                              <v-text-field
                                v-model="loggedInUserData.phone_number"
                                name="phone_number"
                                label="Phone Number"
                                :readonly="!loggedInUserData.is_staff"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex class="col-sm-12 col-md-6">
                              <v-text-field
                                v-model="loggedInUserData.address"
                                name="address"
                                label="Address"
                                v-validate="'required|min:3'"
                                :error-messages="errors.collect('Address')"
                                data-vv-name="Address"
                              >
                              </v-text-field>
                            </v-flex>
                            <!-- <v-flex
                              v-if="!loggedInUserData.is_staff"
                              class="col-sm-12 col-md-6"
                            >
                              <v-select
                                :items="branchesList"
                                v-model="loggedInUserData.default_branch_id_fk"
                                autocomplete
                                label="Branch"
                              />
                            </v-flex> -->
                          </div>
                          <div class="row">
                            <v-flex class="col-sm-12 col-md-6 col-md-offset-3">
                              <v-btn
                                type="submit"
                                style="height:auto; width:100%"
                                color="success"
                              >Save</v-btn>
                            </v-flex>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /PERSONAL INFORMATION -->

                <!-- RESET PASSWORD -->
                <div
                  class="tab-pane fade"
                  id="settings"
                >
                  <div class="panel panel-flat">
                    <div class="panel-heading">
                      <h3 class="panel-title">Change Password</h3>
                    </div>
                    <br />

                    <div class="panel-body">
                      <div
                        id="password_validation"
                        class="col-sm-8 col-md-offset-2"
                        style="text-align: left; color: #ff4c22; font-size: large "
                      ></div>
                      <div
                        id="password_success"
                        class="col-sm-8 col-md-offset-2"
                        style="text-align: left; color: #4cb743; font-size: large "
                      ></div>
                      <div class="col-sm-12">
                        <form
                          action=""
                          @submit.prevent="changePassword(loggedInUserData.user_id)"
                        >
                          <div class="row">
                            <v-flex sm6>
                              <v-text-field
                                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e1 = !e1)"
                                :type="e1 ? 'password' : 'text'"
                                name="current_password"
                                label="Current password"
                                v-model="changePasswordData.current_password"
                                :error-messages="errors.collect('Current password')"
                                v-validate="'required|min:6'"
                                data-vv-name="Current password"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex sm6>
                              <v-text-field
                                :append-icon="e2 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e2 = !e2)"
                                :type="e2 ? 'password' : 'text'"
                                name="new_password"
                                label="New password"
                                v-model="changePasswordData.new_password"
                                :error-messages="errors.collect('New password')"
                                v-validate="'required|min:6'"
                                data-vv-name="New password"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex sm6>
                              <v-text-field
                                :append-icon="e3 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e3 = !e3)"
                                :type="e3 ? 'password' : 'text'"
                                name="confirm_password"
                                label="Confirm password"
                                v-model="changePasswordData.confirm_password"
                                :error-messages="errors.collect('Confirm password')"
                                v-validate="'required|min:6'"
                                data-vv-name="Confirm password"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex sm6>
                              <v-btn
                                type="submit"
                                style="height:auto; width:100%"
                                color="success"
                              >Change Password</v-btn>
                            </v-flex>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /RESET PASSWORD -->

                <!-- CHANGE SECRET KEY -->
                <div
                  class="tab-pane fade"
                  id="secret"
                >
                  <div class="panel panel-flat">
                    <div class="panel-heading">
                      <h3 class="panel-title">Change Secret Key</h3>
                    </div>
                    <br />
                    <div class="col-sm-12 col-md-6">
                      <v-alert
                        :value="backErr"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Current secret key is not correct
                      </v-alert>
                      <v-alert
                        :value="backSucc"
                        color="green"
                        icon="success"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Secret key changed successfully
                      </v-alert>
                      <v-alert
                        :value="currSec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Current secret key is required
                      </v-alert>
                      <v-alert
                        :value="newSec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        New secret key is required
                      </v-alert>
                      <v-alert
                        :value="confSec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Confirm secret key is required
                      </v-alert>
                      <v-alert
                        :value="matchSec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Confirm secret is not match
                      </v-alert>
                    </div>

                    <div class="panel-body">
                      <div class="col-sm-12">
                        <form
                          action=""
                          @submit.prevent="updateSecret(loggedInUserData.user_id)"
                        >
                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                :append-icon="e4 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e4 = !e4)"
                                :type="e4 ? 'password' : 'text'"
                                label="Current secret"
                                v-model="updateSecretData.current_secret_key"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                :append-icon="e5 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e5 = !e5)"
                                :type="e5 ? 'password' : 'text'"
                                label="New secret"
                                v-model="updateSecretData.secret_key"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                :append-icon="e6 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e6 = !e6)"
                                :type="e6 ? 'password' : 'text'"
                                label="Confirm secret"
                                v-model="updateSecretData.confirm_secret_key"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex sm6>
                              <v-btn
                                type="submit"
                                style="height:auto; width:100%"
                                color="success"
                              >Save</v-btn>
                            </v-flex>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /CHANGE SECRET KEY -->

                <!-- CREATE SECRET KEY -->
                <div
                  class="tab-pane fade"
                  id="create-secret"
                >
                  <div class="panel panel-flat">
                    <div class="panel-heading">
                      <h3 class="panel-title">Create Secret Key</h3>
                    </div>
                    <br />
                    <div class="col-sm-12 col-md-6">
                      <v-alert
                        :value="backSucc"
                        color="green"
                        icon="success"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Secret key created successfully
                      </v-alert>
                      <v-alert
                        :value="backErr"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        You already have a secret key
                      </v-alert>
                      <v-alert
                        :value="Sec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Secret key is required
                      </v-alert>
                      <v-alert
                        :value="confSec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Confirm secret key is required
                      </v-alert>
                      <v-alert
                        :value="matchSec"
                        color="red"
                        icon="warning"
                        style="padding: 2px; margin-bottom: 4%"
                      >
                        Confirm secret is not match
                      </v-alert>
                    </div>

                    <div class="panel-body">
                      <div class="col-sm-12">
                        <form
                          action=""
                          @submit.prevent="createSecret()"
                        >
                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                :append-icon="e7 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e7 = !e7)"
                                :type="e7 ? 'password' : 'text'"
                                label="Secret key"
                                v-model="createSecretData.secret_key"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                :append-icon="e8 ? 'visibility' : 'visibility_off'"
                                :append-icon-cb="() => (e8 = !e8)"
                                :type="e8 ? 'password' : 'text'"
                                label="Confirm secret"
                                v-model="createSecretData.confirm_secret_key"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex sm6>
                              <v-btn
                                type="submit"
                                style="height:auto; width:100%"
                                color="success"
                              >Create</v-btn>
                            </v-flex>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /CREATE SECRET KEY -->

                <!-- COMPANY INFO -->
                <div
                  class="tab-pane fade"
                  id="company"
                >
                  <div class="panel panel-flat">
                    <div class="panel-heading">
                      <h3 class="panel-title">Company info</h3>
                    </div>
                    <br />
                    <div class="col-sm-12 col-md-6">
                      <v-alert
                        :value="compsuccess"
                        color="green"
                        icon="success"
                        style="padding: 6px; margin-bottom: 4%"
                      >
                        Company info updated successfully
                      </v-alert>

                      <v-alert
                        :value="comperror"
                        color="red"
                        icon="warning"
                        style="padding: 6px; margin-bottom: 4%"
                      >
                        Please update anything
                      </v-alert>
                    </div>

                    <div class="panel-body">
                      <div class="col-sm-12">
                        <form
                          action=""
                          @submit.prevent="updateCompanyInfo()"
                        >
                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                label="Company name"
                                v-validate="'required'"
                                data-vv-name="Company name"
                                :error-messages="errors.collect('Company name')"
                                v-model="companyData.company_name"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                label="Company email"
                                v-validate="'required|email'"
                                data-vv-name="Company email"
                                :error-messages="errors.collect('Company email')"
                                v-model="companyData.company_email"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                label="Phone Number"
                                v-validate="'required'"
                                data-vv-name="Phone Number"
                                :error-messages="errors.collect('Phone Number')"
                                v-model="companyData.phone_number"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex
                              sm12
                              md6
                            >
                              <v-text-field
                                label="Company address"
                                v-validate="'required'"
                                data-vv-name="Company address"
                                :error-messages="errors.collect('Company address')"
                                v-model="companyData.company_address"
                              ></v-text-field>
                            </v-flex>
                          </div>

                          <div class="row">
                            <v-flex sm6>
                              <v-btn
                                type="submit"
                                style="height:auto; width:100%"
                                color="success"
                              >Save</v-btn>
                            </v-flex>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /COMPANY INFO-->
              </div>
            </div>
          </div>
        </div>
        <!-- /User profile -->
      </div>
      <!-- /Main content -->
    </div>
    <!-- /Page content -->
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  created() {
    this.getLoggedInUser()
    this.hostName = window.location.hostname
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      branchesList: [],
      hostName: '',
      e1: true,
      e2: true,
      e3: true,
      e4: true,
      e5: true,
      e6: true,
      e7: true,
      e8: true,
      errorResponse: false,
      successResponse: false,
      currSec: false,
      newSec: false,
      confSec: false,
      matchSec: false,
      backErr: false,
      backSucc: false,
      Sec: false,
      compsuccess: false,
      comperror: false,
      errorMessages: {
        email: '',
        phone_number: ''
      },
      errorMessage: '',
      successMessage: '',
      updateProfileUrl: 'api/users',
      changePasswordUrl: 'api/users',
      updateProfileImageUrl: 'api/users',
      updateSecretUrl: 'api/update_secret',
      createSecretUrl: 'api/add_secret',
      companyUrl: 'api/company_info',
      loggedInUserData: {},
      changePasswordData: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      updateSecretData: {
        current_secret_key: '',
        secret_key: '',
        confirm_secret_key: ''
      },
      createSecretData: {
        secret_key: '',
        confirm_secret_key: ''
      },
      updateProfileData: {
        full_name: '',
        email: '',
        address: '',
        phone_number: ''
      },
      companyData: {}
    }
  },

  mounted() {
    $('.panel-flat').css({ 'overflow-x': 'hidden' })
    this.getCompanyInfo()
    this.getBranchesList()
  },

  methods: {
    getBranchesList() {
      this.branchesList = []

      let token = localStorage.getItem('access_token')
      axios
        .get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          response.data.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    updateCompanyInfo() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.companyUrl + '/' + 1, this.companyData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.comperror = false
          this.compsuccess = true
        })
        .then(() => {
          let a = this
          setTimeout(function () {
            a.compsuccess = false
          }, 3000)
        })
        .catch(() => {
          this.compsuccess = false
          this.comperror = true
        })
        .then(() => {
          let b = this
          setTimeout(function () {
            b.comperror = false
          }, 3000)
        })
    },

    getCompanyInfo() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.companyData = response.data.data
        })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    updateProfile(id) {
      let token = localStorage.getItem('access_token')
      this.updateProfileData.full_name = this.loggedInUserData.full_name
      this.updateProfileData.email = this.loggedInUserData.email
      this.updateProfileData.address = this.loggedInUserData.address
      this.updateProfileData.phone_number = this.loggedInUserData.phone_number
      // this.updateProfileData.default_branch_id_fk = this.loggedInUserData.default_branch_id_fk

      //this.$validator.validateAll().then((res) => {
        //if (res) {
      axios
        .put(this.updateProfileUrl + '/' + id, this.updateProfileData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getUser()
          this.successMessage = response.data.message
          this.successResponse = true
          this.errorResponse = false
        })
        .then(() => {
          let a = this
          setTimeout(function () {
            a.successResponse = false
          }, 3000)
        })
        .catch(error => {
          if (!error.response.data.message.email && !error.response.data.message.phone_number) {
            this.errorMessages.phone_number = ''
            this.errorMessages.email = ''
            this.errorMessage = error.response.data.message
          } else if (error.response.data.message.email) {
            this.errorMessage = ''
            this.errorMessages.phone_number = ''
            this.errorMessages.email = error.response.data.message.email[0]
          } else if (error.response.data.message.phone_number) {
            this.errorMessage = ''
            this.errorMessages.email = ''
            this.errorMessages.phone_number = error.response.data.message.phone_number[0]
          }
          this.errorResponse = true
          this.successResponse = false
        })
        .then(() => {
          let b = this
          setTimeout(function () {
            b.errorResponse = false
          }, 3000)
        })
        //}
      //})
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
        this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      })
    },

    changePassword(id) {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (
            this.changePasswordData.new_password.trim() !==
            this.changePasswordData.confirm_password.trim()
          ) {
            swal('Error', 'Confirm password not match', 'error')
          } else {
            let token = localStorage.getItem('access_token')
            axios
              .put(
                this.changePasswordUrl + '/' + id + '/change_password',
                this.changePasswordData,
                { headers: { Authorization: 'Bearer ' + token } }
              )
              .then(response => {
                this.$validator.reset()
                this.changePasswordData.current_password = ''
                this.changePasswordData.new_password = ''
                this.changePasswordData.confirm_password = ''

                swal('Success', 'Password Changed Successfully', 'success')
              })
              .catch(() => {
                swal('Error', 'Current Password is not correct', 'error')
              })
          }
        }
      })
    },

    updateSecret(id) {
      if (this.updateSecretData.current_secret_key.trim() === '') {
        this.currSec = true
        let x = this
        setTimeout(function () {
          x.currSec = false
        }, 2000)
      }
      if (this.updateSecretData.secret_key.trim() === '') {
        this.newSec = true
        let y = this
        setTimeout(function () {
          y.newSec = false
        }, 2000)
      }
      if (this.updateSecretData.confirm_secret_key.trim() === '') {
        this.confSec = true
        let z = this
        setTimeout(function () {
          z.confSec = false
        }, 2000)
      } else if (
        this.updateSecretData.secret_key.trim() !== this.updateSecretData.confirm_secret_key.trim()
      ) {
        this.matchSec = true
        let m = this
        setTimeout(function () {
          m.matchSec = false
        }, 2000)
      } else {
        let token = localStorage.getItem('access_token')
        axios
          .put(this.updateSecretUrl + '/' + id, this.updateSecretData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            this.backSucc = true
            this.updateSecretData.current_secret_key = ''
            this.updateSecretData.secret_key = ''
            this.updateSecretData.confirm_secret_key = ''

            let n = this
            setTimeout(function () {
              n.backSucc = false
            }, 2000)
          })
          .catch(() => {
            this.backErr = true
            let i = this
            setTimeout(function () {
              i.backErr = false
            }, 2000)
          })
      }
    },

    createSecret() {
      if (this.createSecretData.secret_key.trim() === '') {
        this.Sec = true
        let y = this
        setTimeout(function () {
          y.Sec = false
        }, 2000)
      }
      if (this.createSecretData.confirm_secret_key.trim() === '') {
        this.confSec = true
        let z = this
        setTimeout(function () {
          z.confSec = false
        }, 2000)
      } else if (
        this.createSecretData.secret_key.trim() !== this.createSecretData.confirm_secret_key.trim()
      ) {
        this.matchSec = true
        let m = this
        setTimeout(function () {
          m.matchSec = false
        }, 2000)
      } else {
        let token = localStorage.getItem('access_token')
        axios
          .post(this.createSecretUrl, this.createSecretData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            this.backSucc = true
            this.createSecretData.secret_key = ''
            this.createSecretData.confirm_secret_key = ''

            let n = this
            setTimeout(function () {
              n.backSucc = false
            }, 2000)
          })
          .catch(() => {
            this.backErr = true
            let i = this
            setTimeout(function () {
              i.backErr = false
            }, 2000)
          })
      }
    },

    openExplorer() {
      $('#profile_image').click()
      $('#profile_image').on('change', function (event) {
        $('#updateButton').click()
      })
    },

    openCoverExplorer() {
      $('#cover_image').click()
      $('#cover_image').on('change', function (event) {
        $('#updateCoverButton').click()
      })
    },

    submit(event) {
      let profilePic = document.getElementById('profile_image').files[0]
      if (profilePic.type.includes('image/')) {
        let formData = new FormData(event.target)

        formData.append('profile_image', document.getElementById('profile_image').files[0])
        let token = localStorage.getItem('access_token')
        let userData = JSON.parse(localStorage.getItem('user_data'))

        axios
          .post(this.updateProfileImageUrl + '/' + userData.user_id + '/profile_image', formData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            this.getUser()
            this.$emit('clicked')
          })
          .catch(error => {
            swal('Error', `${error.response.data.message.profile_image[0]}`, 'error')
          })
      } else {
        swal('Error', 'Profile must be an image', 'error')
      }
    },

    submitCover() {
      let coverPic = document.getElementById('cover_image').files[0]
      if (coverPic.type.includes('image/')) {
        let formData = new FormData(event.target)
        formData.append('cover_image', document.getElementById('cover_image').files[0])
        let token = localStorage.getItem('access_token')
        let userData = JSON.parse(localStorage.getItem('user_data'))

        axios
          .post(this.updateProfileImageUrl + '/' + userData.user_id + '/cover_image', formData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            this.getUser()
          })
          .catch(error => {
            swal('Error', `${error.response.data.message.cover_image[0]}`, 'error')
          })
      } else {
        swal('Error', 'Cover must be an image', 'error')
      }
    }
  }
}
</script>

<style scoped>
.panel-heading {
  color: #314149 !important;
  border-bottom: 2px solid #314149 !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userProfile.vue